export default __webpack_public_path__ + "static/media/ddsu5168-7.01130cae.png";